import React, {FC, ReactNode} from 'react'
import classnames from 'classnames'

// @ts-ignore
import styles from './HoverDescription.scss'

export type HoverDescriptionType = {
  children: ReactNode
  isHover: boolean
}

export const HoverDescription: FC<HoverDescriptionType> = ({children, isHover = false}) => {
  const classNames = isHover ? [styles.disabledReason, styles.visible] : [styles.disabledReason]

  return (
    <div className={classnames(classNames)}>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  )
}

export type DescriptionContainerType = JSX.IntrinsicElements['div'] & {
  children: ReactNode
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export const DescriptionContainer: FC<DescriptionContainerType> = ({
  children,
  onMouseEnter,
  onMouseLeave,
  className,
  ...divProps
}) => {
  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={classnames(styles.container, className)}
      {...divProps}
    >
      {children}
    </div>
  )
}
